import { trackOpenNoLinksPopup } from './tracking';
import { IWsErrorEvent } from './types';
import { currentChatOpponentIdSelector } from '../../selectors';
import { checkUsersSession } from '../../services/checkUsersSession';
import { EAlert } from '../../types/alert';
import { ERequestApiStatus, EWsClientEventType, TAppState } from '../../types/appState';
import { TMessageSchema } from '../../types/messages';
import { TThunkAction } from '../../types/redux/thunk';
import { EWsCodeError, EWsErrorMessage } from '../../types/wsErrorMessage';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { showAlert } from '../alert';
import { setSendMessageAbort, setSendMessageFailed } from '../sendMessage';

export const setWsError =
  (event: IWsErrorEvent): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const {
      socket: { clientEvents },
      chatWindow: { messagesMap },
    }: TAppState = state;
    const { uid, error } = event;
    const clientEvent = clientEvents.get(uid);
    const opponentId = currentChatOpponentIdSelector(state);

    if (!clientEvent) {
      return;
    }

    clientEvents.set(uid, { ...clientEvent, status: ERequestApiStatus.Failed });

    if (error.message === EWsErrorMessage.SessionExpired || error.message === EWsErrorMessage.InvalidSession) {
      await dispatch(checkUsersSession());
    }

    const messageItem = messagesMap.get(uid);

    if (clientEvent.type !== EWsClientEventType.Message || !messageItem) {
      return;
    }

    const {
      message: {
        message: { message: text, userId },
        chatId,
      },
    } = messageItem;

    if (error.message === EWsErrorMessage.ValidationError && error.errors.length) {
      const isLinkError = error.errors.some(
        (error: { code: string }) => error.code === EWsCodeError.MessageHasLinkToAnotherService,
      );
      if (isLinkError) {
        dispatch(setSendMessageAbort({ message: { chatId } as TMessageSchema, messageId: uid }));
        clientEvents.delete(uid);
        dispatch(showAlert({ type: EAlert.MessageHasLinkToAnotherService, message: text, chatId }));
        trackOpenNoLinksPopup(opponentId);

        return;
      }
    }

    const message = createOutcomingMessage({ text, chatId, userId });
    dispatch(setSendMessageFailed({ message, messageId: uid }));
  };
